import {api} from '../../../services/ApiService';
import {createRequest} from '../../../helpers/RequestHelper';


export function confirmarEmail(hash, onSuccess, onError) {
    const data = {}
    const url = `/submits/confirmar/${hash}`
    return createRequest({
        api: api, method: 'Post', path: url, data, onSuccess, onError
    });
}


// WEBPACK FOOTER //
// ./src/view/formulario/confirmacao/Actions.js